import React from "react";

const Unauthorized = () => {
  return (
    <div style={{ textAlign: "center", padding: "2rem" }}>
      <h2>No autorizado</h2>
      <p>No tienes permisos para acceder a esta página.</p>
    </div>
  );
};

export default Unauthorized;
